var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4412 30.4363C24.0081 30.4363 30.1422 24.3022 30.1422 16.7353C30.1422 9.1685 24.0081 3.03436 16.4412 3.03436C8.87437 3.03436 2.74023 9.1685 2.74023 16.7353C2.74023 24.3022 8.87437 30.4363 16.4412 30.4363Z",
    fill: "#F89C47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0713,
    y: 9.88483,
    width: 2.7402,
    height: 10.9608,
    rx: 1,
    fill: "#F89C47"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0713,
    y: 22.2157,
    width: 2.7402,
    height: 2.7402,
    rx: 1,
    fill: "#F89C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateInfo);
export default __webpack_public_path__ + "static/media/deactivateInfo.5cd8fc2097236497df82e0065ca88aad.svg";
export { ForwardRef as ReactComponent };